// 請求書 新規作成・編集画面
import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Grid,
  Theme,
  Divider,
  Button,
  Snackbar,
  Dialog,
  DialogActions,
  DialogTitle,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  LinearProgress,
  Checkbox
} from '@material-ui/core';
import { makeStyles, createStyles, withStyles } from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import NumberInput from '../components/NumberInput';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import './List.css';
import { useHistory, Redirect, useParams, useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  mainBlueColor,
  btnColor,
  isLoggedIn,
  tenantTaxRuleState,
  userIdState,
  unbilledAlerts
} from '../GlobalState';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import {
  getConstructEstimate,
  getDeliveryMethods,
  getConstructId_by_client,
  checkInvoiceByEstimateId,
  getBillingCategory,
  createInvoices,
  updateInvoices,
  getInvoiceDetails,
  deleteSingleInvoice
} from '../apicalls/invoices';
import { getConstructionDetails } from '../apicalls/construction';
import {
  getCompanyFreeField,
  getBankList
} from '../apicalls/companyInformation';
import { getEndOfDay } from '../apicalls/createCustomer';
import LoadingComponent from '../components/LoadingComponent';
import { invoicePdf } from '../generatePdf/invoicePdf/invoicePdf';
import { savePdf } from '../apicalls/savePdf';
import { parsePrice } from '../utils';
import { calcTax, formatDatetime } from '../utils/common';
import { DateField } from '../components/molecules';
import {
  DOCUMENT_TYPE,
  EMPLOYEE_TYPE,
  TAX_RULE,
  BILLING_TYPE,
  INVOICE_OPERATION_USER_KEY,
  EMPLOYEE_STATUS
} from '../const/Const';
import { DocumentDeleteModal } from '../components/DocumentDeleteModal';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { TTopicPathState } from '../components/topicPath/type/Type';
import HelpIcon from '@material-ui/icons/Help';
import { flush } from '@sentry/react';
import { TableTitle } from '../components/editInvoice/TableTitle';
import { PriceTableCell } from '../components/editInvoice/PriceTableCell';
import { PriceTableTitle } from '../components/editInvoice/PriceTableTitle';
import { SelectPullDown } from '../components/editInvoice/SelectPullDown';
import { PriceInput } from '../components/editInvoice/PriceInput';
import { ReturnButton } from '../components/editInvoice/ReturnButton';
import { InputArea } from '../components/editInvoice/InputArea';
import { UserDate } from '../components/editInvoice/UserDate';
import { EstimatesTable } from '../components/editInvoice/EstimatesTable';
import { InvoiceFooter } from '../components/editInvoice/InvoiceFooter';
import { getUnbilledAlerts } from '../components/topicPath/BillingAlerts';
import { StaffData } from '../types/staffData';

interface Estimate {
  [key: string]: any;
  id: number;
  quantity: number;
  code: string;
  billingTotal: number;
  billingTotalSum: number;
  invoicePrice: number;
}
const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    borderRight: '1px #CCCCCC solid'
  },
  body: {
    fontSize: 16,
    padding: 0,
    height: 60,
    borderRight: '1px #CCCCCC solid'
  }
}))(TableCell);

export const EditInvoice: React.FC = () => {
  const history: any = useHistory();
  const location: any = useLocation();

  const [mainColor] = useRecoilState(mainBlueColor);
  const [tenantTaxRule] = useRecoilState(tenantTaxRuleState);
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [userData, setUserData] = useState([]);
  const [clientId, setClientId] = useState<number>(0);
  const [closingDateId, setClosingDateId] = useState<number>(0);
  const [depositSite, setDepositSite] = useState('');
  const [clientName, setClientName] = useState('');
  const [honorificTitle, setHonorificTitle] = useState('御中');
  const [contractorName, setContractorName] = useState('');
  const [freeField, setFreeField] = useState('');
  const [payee, setPayee] = useState('');
  const [invoiceCode, setInvoiceCode] = useState('');
  const [constructId, setConstructId] = useState(0);
  const [constructCode, setConstructCode] = useState('');
  const [constructSub, setConstructSub] = useState('');
  const [receiptNote, setReceiptNote] = useState('');
  const [createdUser, setCreatedUser] = useState('');
  const [createdAt, setCreatedAt] = useState('');
  const [updatedUser, setUpdatedUser] = useState('');
  const [updatedAt, setUpdatedAt] = useState('');
  const [alreadyPaid, setAlreadyPaid] = useState('');

  const [constructionEstimates, setConstructionEstimates] = useState<
    Estimate[]
  >([]);
  const [billingCategory, setBillingCategory] = useState([]);
  const [deliveryMethod, setDeliveryMethod] = useState([]);

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [paymentDateValue, setPaymentDateValue] = useState('');
  const [publishedDateValue, setPublishedDateValue] = useState('');
  const [confirmDateValue, setConfirmDateValue] = useState('');
  const [receiptIssueFlg, setReceiptIssueFlg] = useState<number>(0);
  const [status, setStatus] = useState(2);
  const [billingUserId, setBillingUserId] = useState<number>(0);
  const [salesUserId, setSalesUserId] = useState<number>(0);
  const [initialBillingUserData, setInitialBillingUserData] =
    useState<StaffData | null>(null);
  const [initialSalesUserData, setInitialSalesUserData] =
    useState<StaffData | null>(null);
  const [deliveryMethodId, setDeliveryMethodId] = useState<number>(0);
  const [billingTypeId, setBillingTypeId] = useState<number>(0);
  const [contractTotal, setContractTotal] = useState<number | string>();
  const [billingTotal, setBillingTotal] = useState<number | string>();
  const [balanceTotal, setBalanceTotal] = useState<number | string>();
  const [taxRule, setTaxRule] = useState<number>(tenantTaxRule);
  const [remarks, setRemarks] = useState('');
  const [memo, setMemo] = useState('');
  const [estimates, setEstimates] = useState<Estimate[]>(
    history.location.state.estimateId
      ? [
          {
            id: history.location.state.estimateId,
            quantity: 0,
            constructionName: '',
            code: '',
            billingTotal: 0,
            billingTotalSum: 0,
            invoicePrice: 0
          }
        ]
      : []
  );
  const [paymentDate, setPaymentDate] = useState<Date | null>(null);
  const [publishedDate, setPublishedDate] = useState<Date | null>(null);
  const [confirmDate, setConfirmDate] = useState<Date | null>(null);
  const [billingTotalTax, setBillingTotalTax] = useState(0);
  const [taxRate, setTaxRate] = useState(() => {
    const state = history.location.state;
    if (state.estimateId) {
      return state.taxRate;
    } else if (state.source === 'customer') {
      return 0.1;
    } else {
      return 0;
    }
  });

  const [billingTotalPrice, setBillingTotalPrice] = useState(0);
  //ユーザーidの取得
  const [userId, setUserId] = useRecoilState<number>(userIdState);

  const [loading, setLoading] = useState(true);
  const [showLinearProgress, setShowLinearProgress] = useState(false);
  const [invoiceDetailData, setInvoiceDetailData] = useState<any>({});
  const [isRendered, setIsRendered] = useState(false);
  const [endOfDay, setEndOfDay] = useState([]);
  // 請求書の営業担当を出力するかどうかをローカルストレージに保存する際のkey
  const setOperationUser = INVOICE_OPERATION_USER_KEY + userId;
  // ローカルストレージを取得し格納
  const storedOutPutPdf = localStorage.getItem(setOperationUser);
  const [outPutPdf, setOutPutPdf] = useState(
    storedOutPutPdf ? JSON.parse(storedOutPutPdf) : false
  );
  const [outPutDetails, setOutPutDetails] = useState(false);
  const [, setAlertList] = useRecoilState(unbilledAlerts);

  // 帳票削除アラート
  const [documentDeleteModal, setDocumentDeleteModal] =
    useState<boolean>(false);

  /**
   * 支払期日
   */
  const handlePaymentDateChange = (date: Date | null) => {
    setPaymentDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setPaymentDateValue(finaldate);
  };

  const [source, setSource] = useState(location.state.source);
  const calcPaymentDate = (clientId: number, date: any) => {
    if (clientId === 0 || depositSite === '') {
      return;
    }
    // return

    if (date) {
      // 請求書発行日
      let copySelectedPublishedDate: any = date;
      // 締日の取得
      let selectedEndDate: any = endOfDay.filter(
        (item: any) => item.id === closingDateId
      );
      // 支払い月の取得
      let clientPaymentSiteMonthList: any = [
        { name: '当月', month: 0 },
        { name: '翌月', month: 1 },
        { name: '翌々月', month: 2 },
        { name: '翌々々月', month: 3 }
      ];

      let clientPaymentSiteMonth: any = clientPaymentSiteMonthList.filter(
        (item: any) => {
          // 顧客の支払サイト
          if (item.name.length < 3) {
            return item.name === depositSite.slice(0, 2); // 当月、翌月
          } else if (item.name.length === 3) {
            return item.name === depositSite.slice(0, 3); // 翌々月
          } else {
            return item.name === depositSite.slice(0, 4); // 翌々々月
          }
        }
      );
      // 支払日の取得
      let clientDepositSiteDay: any = '';

      if (depositSite.slice(-1) !== '末') {
        // '末'や数字がくる
        // 末でない場合
        clientDepositSiteDay =
          depositSite.slice(-2) === '-5' ? 5 : depositSite.slice(-2); //5, 10, 15, 25
      } else {
        // 末の場合
        // +1することで正しい月になる
        let a = new Date(
          copySelectedPublishedDate.getFullYear(),
          copySelectedPublishedDate.getMonth() +
            1 +
            clientPaymentSiteMonth[0].month,
          0
        );
        clientDepositSiteDay = a.getDate(); // 選択した月の日数
      }

      // 請求書発行日が締日の前後どちらかを判定する為のデータ
      // 請求書発行日のタイムスタンプ取得
      const copyPublishedDate: number = new Date(
        copySelectedPublishedDate.getFullYear(),
        copySelectedPublishedDate.getMonth(),
        copySelectedPublishedDate.getDate()
      ).getTime();
      // 請求書発行日の年月+締日(末の場合は0)のタイムスタンプ
      const maxEndDate: number = new Date(
        copySelectedPublishedDate.getFullYear(),
        copySelectedPublishedDate.getMonth() +
          (selectedEndDate[0].name === '末日' ? +1 : 0),
        selectedEndDate[0].name === '末日' ? 0 : selectedEndDate[0].name
      ).getTime();

      // 支払日が当月のデータを除外した処理
      if (
        depositSite.slice(-1) !== '末' &&
        clientPaymentSiteMonth[0].name !== '当月'
      ) {
        // 支払日が末でない
        // 請求書発行日が締日より前か後かの処理
        if (copyPublishedDate <= maxEndDate) {
          // 請求書発行日が締め日より前
          let setDate = new Date(
            copySelectedPublishedDate.getFullYear(),
            copySelectedPublishedDate.getMonth() +
              clientPaymentSiteMonth[0].month,
            clientDepositSiteDay,
            12
          );
          handlePaymentDateChange(setDate);
        } else {
          let setDate = new Date(
            copySelectedPublishedDate.getFullYear(),
            copySelectedPublishedDate.getMonth() +
              clientPaymentSiteMonth[0].month +
              1,
            clientDepositSiteDay,
            12
          );
          handlePaymentDateChange(setDate);
        }
      } else if (
        depositSite.slice(-1) === '末' &&
        clientPaymentSiteMonth[0].name !== '当月'
      ) {
        // 支払日が末だった場合
        if (copyPublishedDate <= maxEndDate) {
          let endOfTheMonth = new Date(
            copySelectedPublishedDate.getFullYear(),
            copySelectedPublishedDate.getMonth() +
              clientPaymentSiteMonth[0].month +
              1,
            0,
            12
          );
          handlePaymentDateChange(endOfTheMonth);
        } else {
          let endOfTheMonth = new Date(
            copySelectedPublishedDate.getFullYear(),
            copySelectedPublishedDate.getMonth() +
              clientPaymentSiteMonth[0].month +
              2,
            0,
            12
          );
          handlePaymentDateChange(endOfTheMonth);
        }
        //
        // 以下、支払い月が「当月」の処理。締日より支払日が前にあった場合に、誤った日付が入るのを防ぐ
        //
      } else if (
        depositSite.slice(-1) !== '末' &&
        selectedEndDate[0].name <= clientDepositSiteDay
      ) {
        if (copyPublishedDate <= maxEndDate) {
          let setDate = new Date(
            copySelectedPublishedDate.getFullYear(),
            copySelectedPublishedDate.getMonth(),
            clientDepositSiteDay,
            12
          );
          handlePaymentDateChange(setDate);
        } else {
          let setDate = new Date(
            copySelectedPublishedDate.getFullYear(),
            copySelectedPublishedDate.getMonth() + 1,
            clientDepositSiteDay,
            12
          );
          handlePaymentDateChange(setDate);
        }
      } else if (
        depositSite.slice(-1) !== '末' &&
        clientDepositSiteDay < selectedEndDate[0].name
      ) {
        if (copyPublishedDate <= maxEndDate) {
          let setDate = new Date(
            copySelectedPublishedDate.getFullYear(),
            copySelectedPublishedDate.getMonth() + 1,
            clientDepositSiteDay,
            12
          );
          handlePaymentDateChange(setDate);
        } else {
          let setDate = new Date(
            copySelectedPublishedDate.getFullYear(),
            copySelectedPublishedDate.getMonth() + 2,
            clientDepositSiteDay,
            12
          );
          handlePaymentDateChange(setDate);
        }
      } else if (depositSite.slice(-1) === '末') {
        if (copyPublishedDate <= maxEndDate) {
          let setDate = new Date(
            copySelectedPublishedDate.getFullYear(),
            copySelectedPublishedDate.getMonth() + 1,
            0,
            12
          );
          handlePaymentDateChange(setDate);
        } else {
          let setDate = new Date(
            copySelectedPublishedDate.getFullYear(),
            copySelectedPublishedDate.getMonth() + 2,
            0,
            12
          );
          handlePaymentDateChange(setDate);
        }
      }
    }
  };

  /**
   * 請求書発行日
   */
  const handlePublishedDateChange = (date: Date | null) => {
    getAllEndOfDay();
    setPublishedDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setPublishedDateValue(finaldate);
    calcPaymentDate(clientId, date); // 支払期日を自動設定
  };

  const getAllEndOfDay = () => {
    getEndOfDay().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setEndOfDay(data.data);
          }
        }
      }
    });
  };

  /**
   * 入金日
   */
  const handleConfirmDateChange = (date: Date | null) => {
    setConfirmDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setConfirmDateValue(finaldate);
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const matches2 = useMediaQuery('(min-width:900px)');

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll'
      },
      paper: {
        width: matches2 ? 600 : '80%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      textContainerPrice: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        textAlign: 'right',
        width: '100%'
      },
      input: {
        height: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputBank: {
        fontSize: '13px',
        height: 90,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1,
        resize: 'none'
      },
      fixedTextContainer: {
        fontSize: 14,
        marginLeft: 15,
        marginRight: 15
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        height: 48,
        width: '100%'
      },
      aggreGateTable: {
        width: 500,
        marginLeft: 'auto'
      },
      progress: {
        backgroundColor: '#c1c1c1',
        '& .MuiLinearProgress-barColorPrimary': {
          backgroundColor: mainColor
        }
      }
    })
  );

  const classes = useStyles();
  const params: any = useParams();

  const outPutCheck = () => {
    if (outPutPdf) {
      localStorage.setItem(setOperationUser, JSON.stringify(false));
      setOutPutPdf(false);
    } else {
      localStorage.setItem(setOperationUser, JSON.stringify(true));
      setOutPutPdf(true);
    }
  };

  const getListOfUsers = useCallback(() => {
    getEmployeeMasterList('', 1, 0, EMPLOYEE_TYPE['INSIDE_EMPLOYEE']).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setUserData(data.data);
            }
          }
        }
      }
    );
  }, [changeLoggedInData]);

  //選択中の請求書番号
  const { id: invoice_id }: any = useParams();

  const getTheDetailsOfInvoices = (
    newInvoiceId: any = null,
    goPreview = false
  ) => {
    getInvoiceDetails(newInvoiceId ? newInvoiceId : invoice_id).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            if (
              data.data.construct_id === null ||
              data.data.construct_id === 0
            ) {
              setSource('customer');
            }
            if (newInvoiceId) {
              //code for checking whether the data is updated or not, if any data is updated new pdf will be generated and upload
              let isDataUpdated: boolean = false;

              if (invoiceDetailData['estimates']) {
                if (
                  invoiceDetailData['estimates'].length !==
                  data.data['estimates'].length
                ) {
                  isDataUpdated = true;
                } else {
                  for (
                    let i = 0;
                    i < (invoiceDetailData['estimates'] || []).length;
                    i++
                  ) {
                    if (
                      invoiceDetailData['estimates'][i].id !==
                      data.data['estimates'][i].id
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      invoiceDetailData['estimates'][i].code !==
                      data.data['estimates'][i].code
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      invoiceDetailData['estimates'][i].site_name !==
                      data.data['estimates'][i].site_name
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      invoiceDetailData['estimates'][i].quantity !==
                      data.data['estimates'][i].quantity
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      invoiceDetailData['estimates'][i].billing_total !==
                      data.data['estimates'][i].billing_total
                    ) {
                      isDataUpdated = true;
                      break;
                    }

                    // items プロパティの存在をチェック
                    const oldItems =
                      invoiceDetailData['estimates'][i].items || [];
                    const newItems = data.data['estimates'][i].items || [];
                    if (oldItems.length !== newItems.length) {
                      isDataUpdated = true;
                      break;
                    }

                    for (let j = 0; j < oldItems.length; j++) {
                      if (oldItems[j].id !== newItems[j].id) {
                        isDataUpdated = true;
                        break;
                      }
                      if (oldItems[j].name !== newItems[j].name) {
                        isDataUpdated = true;
                        break;
                      }
                      if (oldItems[j].quantity !== newItems[j].quantity) {
                        isDataUpdated = true;
                        break;
                      }
                      if (oldItems[j].unit !== newItems[j].unit) {
                        isDataUpdated = true;
                        break;
                      }
                      if (
                        oldItems[j].selling_unit_price !==
                        newItems[j].selling_unit_price
                      ) {
                        isDataUpdated = true;
                        break;
                      }
                    }
                  }
                }
              }

              if (isDataUpdated === false && invoiceDetailData['construct']) {
                let oldConstructData = Object.keys(
                  invoiceDetailData['construct']
                );
                let updatedContructData = Object.keys(data.data['construct']);
                if (oldConstructData.length !== updatedContructData.length) {
                  isDataUpdated = true;
                } else {
                  for (let el of updatedContructData) {
                    if (
                      invoiceDetailData['construct'][el] !==
                      data.data['construct'][el]
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                  }
                }
              }

              if (isDataUpdated === false) {
                let oldData = Object.keys(invoiceDetailData);
                let updatedData = Object.keys(data.data);
                oldData = oldData.filter(
                  (char: any, aa: any) => char !== 'construct'
                );
                oldData = oldData.filter(
                  (char: any, aa: any) => char !== 'estimates'
                );
                oldData = oldData.filter(
                  (char: any, aa: any) => char !== 'updated_user_name'
                );
                oldData = oldData.filter(
                  (char: any, aa: any) => char !== 'updated_at'
                );
                oldData = oldData.filter(
                  (char: any, aa: any) => char !== 'updated_at_str'
                );

                updatedData = updatedData.filter(
                  (char: any, aa: any) => char !== 'construct'
                );
                updatedData = updatedData.filter(
                  (char: any, aa: any) => char !== 'estimates'
                );
                updatedData = updatedData.filter(
                  (char: any, aa: any) => char !== 'updated_user_name'
                );
                updatedData = updatedData.filter(
                  (char: any, aa: any) => char !== 'updated_at'
                );
                updatedData = updatedData.filter(
                  (char: any, aa: any) => char !== 'updated_at_str'
                );

                if (oldData.length !== updatedData.length) {
                  isDataUpdated = true;
                } else {
                  for (let el of updatedData) {
                    if (invoiceDetailData[el] !== data.data[el]) {
                      isDataUpdated = true;
                      break;
                    }
                  }
                }
              }

              if (isDataUpdated) {
                uploadInvoicePdf(data.data, newInvoiceId, goPreview);
              } else {
                setShowLinearProgress(false);
                setOpenSuccess(true);
                if (goPreview === true) {
                  history.replace(`/invoices/${newInvoiceId}/preview`, {
                    rowId: history.location.state.rowId,
                    previouspath: history.location.state.previouspath,
                    tabs: history.location.state.tabs,
                    constructId: history.location.state.constructId,
                    params: history.location.state.params,
                    newInvoiceId: newInvoiceId
                  });
                }
              }
            }

            setInvoiceDetailData(data.data);
            setTaxRate(data.data.tax_rate);
            setStatus(data.data.status);
            setClientName(data.data.client_name);
            setClientId(data.data.client_id);
            setHonorificTitle(data.data.honorific_title);
            setContractorName(data.data.contractor_name);
            setPaymentDateValue(data.data.payment_date);
            setReceiptIssueFlg(data.data.receipt_issue_flg);
            if (data.data.payment_date !== '') {
              setPaymentDate(new Date(data.data.payment_date));
            }
            setPayee(data.data.payee);
            setPublishedDateValue(data.data.published_date);
            if (data.data.published_date !== '')
              setPublishedDate(data.data.published_date);
            setConfirmDateValue(data.data.confirm_date);
            if (data.data.confirm_date !== '') {
              setConfirmDate(data.data.confirm_date);
            }
            setConstructSub(data.data.construct_name);
            setReceiptNote(data.data.receipt_note);

            if (typeof data.data.billing_user_id === 'string') {
              setBillingUserId(0);
              setInitialBillingUserData(null);
            } else {
              setBillingUserId(data.data.billing_user_id);
              if (data.data.billing_user_status === EMPLOYEE_STATUS.INACTIVE) {
                const billingUserData: StaffData = {
                  id: data.data.billing_user_id,
                  name: data.data.billing_user_name
                };
                setInitialBillingUserData(billingUserData);
              } else {
                setInitialBillingUserData(null);
              }
            }

            if (data.data.sales_user_status === EMPLOYEE_STATUS.INACTIVE) {
              const salesUserData: StaffData = {
                id: data.data.sales_user_id,
                name: data.data.sales_user_name
              };
              setInitialSalesUserData(salesUserData);
            } else {
              setInitialSalesUserData(null);
            }

            setSalesUserId(data.data.sales_user_id);
            setOutPutPdf(
              storedOutPutPdf
                ? JSON.parse(storedOutPutPdf)
                : data.data.output_pdf
            );
            setOutPutDetails(data.data.output_details);
            setDeliveryMethodId(data.data.delivery_method_id);
            setBillingTypeId(data.data.billing_type_id);
            setFreeField(data.data.free_field);
            setAlreadyPaid(data.data.already_paid);
            setBillingTotal(data.data.billing_total);
            setBalanceTotal(data.data.balance_total);
            setTaxRule(data.data.tax_rule);
            /* if (data.data.already_paid) {
              setAlreadyPaid(data.data.already_paid);
            }
            if (data.data.billing_total) {
              setBillingTotal(data.data.billing_total);
            }
            if (data.data.balance_total) {
              setBalanceTotal(data.data.balance_total);
            }*/
            setRemarks(data.data.remarks);
            setMemo(data.data.memo);
            getListOfEstimates(data.data.estimates);
            setInvoiceCode(data.data.code);
            setConstructCode(data.data.construct_code);
            setConstructId(history.location.state.constructId);
            setCreatedUser(data.data.created_user_name);
            setUpdatedUser(data.data.updated_user_name);
            setCreatedAt(data.data.created_at_str);
            setUpdatedAt(data.data.updated_at_str);
            setContractTotal(data.data.contract_total);
            setLoading(false);
          }
        }
      }
    });
  };

  //upload pdf
  const uploadInvoicePdf = async (
    pdfData: any,
    newInvoiceId: number,
    goPreview: boolean
  ) => {
    let blob = await invoicePdf(pdfData);

    const formData: any = new FormData();
    formData.append('document_type_id', JSON.stringify(DOCUMENT_TYPE.INVOICE));
    formData.append('invoice_id', JSON.stringify(newInvoiceId));
    formData.append('file_obj', blob);

    savePdf(formData).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setShowLinearProgress(false);
            setOpenSuccess(true);
            const constructIdforPdf = Number.isInteger(
              Number(history.location.state.constructId)
            )
              ? history.location.state.constructId
              : null;
            if (goPreview === true) {
              history.replace(`/invoices/${newInvoiceId}/preview`, {
                state: history.location.state.rowId,
                previouspath: history.location.state.previouspath,
                tabs: history.location.state.tabs,
                params: history.location.state.params,
                constructId: constructIdforPdf,
                newInvoiceId: newInvoiceId
              });
            } else {
              if (!params.id) {
                setIsRendered(false);
                history.push(`/invoices/${newInvoiceId}/edit`, {
                  state: newInvoiceId,
                  constructId: constructIdforPdf
                });
              }
            }
          }
        }
      }
    });
  };

  const getListOfEstimates = (data: any) => {
    let arr: any = [];
    data.forEach((d: any) => {
      const obj: any = {
        id: d.id,
        code: d.code,
        constructionName: d.construction_name ? d.construction_name : '',
        billingTotal: d.billing_total ? d.billing_total : 0,
        billingTotalSum: d.billing_total,
        invoicePrice: d.invoice_price ? d.invoice_price : 0
      };
      arr.push(obj);
    });
    setEstimates(arr);
  };

  const getListOfBillingCategory = useCallback(() => {
    getBillingCategory().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setBillingCategory(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfDeliveryMethods = useCallback(() => {
    getDeliveryMethods().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setDeliveryMethod(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfConstructionEstimates = useCallback(() => {
    if (
      history.location.state.constructId === null ||
      history.location.state.constructId === undefined
    ) {
      return;
    }

    getConstructEstimate(history.location.state.constructId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            // 重複しないIDを持たせる
            const maxId = data.data.reduce(
              (max: any, item: any) => (item.id > max ? item.id : max),
              0
            );
            const no_estimate = {
              id: maxId + 1,
              code: '見積書なし',
              billingTotal: 0,
              constructionName: ''
            };
            // 発行状況を確認してisIssuedを追加
            const estimatesWithStatusPromises = data.data.map(
              async (estimate: any) => {
                const response = await checkInvoiceByEstimateId(estimate.id);
                const isIssued = response.data && response.data.exists ? 1 : 0;
                return {
                  ...estimate,
                  isIssued // 発行状況を追加
                };
              }
            );

            Promise.all(estimatesWithStatusPromises)
              .then(estimatesWithStatus => {
                setConstructionEstimates([...estimatesWithStatus, no_estimate]);

                if (!params.id && !history.location.state.estimateId) {
                  setTaxRate(data.tax_rate);
                }
                if (!params.id && history.location.state.estimateId) {
                  let arr: any = [];
                  const obj: any = {
                    id: data.data[0].id,
                    quantity: 1,
                    constructionName: data.data[0].construction_name,
                    billingTotal: data.data[0].billing_total,
                    billingTotalSum: data.data[0].billing_total * 1,
                    isIssued: estimatesWithStatus[0].isIssued // isIssuedを使用
                  };
                  arr.push(obj);
                  setEstimates(arr);
                }
              })
              .catch(err => {
                setErrorMessage('見積書データの取得中にエラーが発生しました。');
                setOpen(true);
              });
          }
        }
      }
    });
  }, [changeLoggedInData, history.location.state, params.id]);

  const getListOfEstimatesByClient = useCallback(() => {
    getConstructId_by_client(history.location.state.state.state)
      .then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              const constructIds = data.construction_ids;

              const estimatePromises = constructIds.map((id: number) =>
                getConstructEstimate(id)
              );

              Promise.all(estimatePromises)
                .then(results => {
                  const allData = results.flatMap(result => result.data);
                  const sortedData = allData.sort((a, b) => b.id - a.id);
                  const maxId = sortedData.reduce(
                    (max, item: any) => (item.id > max ? item.id : max),
                    0
                  );
                  const no_estimate = {
                    id: maxId + 1,
                    code: '見積書なし',
                    construct_sub: '',
                    billingTotal: 0,
                    constructionName: '',
                    isIssued: 0 // 発行済みかどうかに関係なく0
                  };
                  const estimatesWithStatusPromises = sortedData.map(
                    async estimate => {
                      try {
                        const response = await checkInvoiceByEstimateId(
                          estimate.id
                        );
                        const isIssued =
                          response.data && response.data.exists ? 1 : 0;
                        return {
                          ...estimate,
                          isIssued
                        };
                      } catch (err) {
                        console.error(
                          `Error checking invoice status for estimate ID ${estimate.id}:`,
                          err
                        );
                        return {
                          ...estimate,
                          isIssued: 0 // エラーが発生した場合は未発行として扱う
                        };
                      }
                    }
                  );

                  Promise.all(estimatesWithStatusPromises)
                    .then(estimatesWithStatus => {
                      setConstructionEstimates([
                        ...estimatesWithStatus,
                        no_estimate
                      ]);
                      if (!params.id && history.location.state.estimateId) {
                        let arr: any = [];
                        const obj: any = {
                          id: sortedData[0].id,
                          quantity: 1,
                          constructionName: sortedData[0].construction_name,
                          billingTotal: sortedData[0].billing_total,
                          billingTotalSum: sortedData[0].billing_total * 1,
                          isIssued: estimatesWithStatus[0].isIssued
                        };
                        arr.push(obj);
                        setEstimates(arr);
                      }
                    })
                    .catch(err => {
                      setErrorMessage(
                        '見積書データの取得中にエラーが発生しました。'
                      );
                      setOpen(true);
                    });
                })
                .catch(err => {
                  setErrorMessage(
                    '見積書データの取得中にエラーが発生しました。'
                  );
                  setOpen(true);
                });
            }
          }
        }
      })
      .catch(err => {
        if (err.response) {
          if (err.response.data) {
            setErrorMessage(
              err.response.data.error || 'エラーが発生しました。'
            );
          } else {
            setErrorMessage('サーバーからの予期しないエラーが発生しました。');
          }
        } else if (err.request) {
          setErrorMessage('サーバーからの応答がありません。');
        } else {
          setErrorMessage('リクエストの設定中にエラーが発生しました。');
        }
        setOpen(true);
      });
  }, [changeLoggedInData, history.location.state, params.id]);

  let existsError = false;

  const updateOrCreateInvoiceDetails = (goPreview: boolean = false) => {
    existsError = false;
    if (status === 0) {
      setErrorMessage('ステータスを選択してください。');
      existsError = true;
      setOpen(true);
    } else if (clientName === null || clientName === '') {
      setErrorMessage('請求先顧客名を入力してください。');
      existsError = true;
      setOpen(true);
    } else if (publishedDate === null) {
      setErrorMessage('請求書発行日を入力してください。');
      existsError = true;
      setOpen(true);
    } else if (contractorName.length > 30) {
      setErrorMessage('契約者名は30文字以内で入力してください。');
      existsError = true;
      setOpen(true);
    } else if (!receiptNote) {
      setErrorMessage('領収書但し書きを入力してください。');
      existsError = true;
      setOpen(true);
    } else if (receiptNote.length > 60) {
      setErrorMessage('領収書但し書きは60文字以内で入力してください。');
      existsError = true;
      setOpen(true);
    } else if (!salesUserId || salesUserId === 0) {
      setErrorMessage('営業担当を選択してください。');
      existsError = true;
      setOpen(true);
    } else if (!deliveryMethodId || deliveryMethodId === 0) {
      setErrorMessage('送付区分を選択してください。');
      existsError = true;
      setOpen(true);
    } else if (!billingTypeId || billingTypeId === 0) {
      setErrorMessage('請求区分を選択してください。');
      existsError = true;
      setOpen(true);
    } else if (freeField && freeField.length > 50) {
      setErrorMessage('自由記入欄は50文字以内で入力してください。');
      existsError = true;
      setOpen(true);
    } else if (isNaN(Number(contractTotal))) {
      setErrorMessage('御契約金額を入力してください。');
      existsError = true;
      setOpen(true);
    } else if (isNaN(Number(billingTotal))) {
      setErrorMessage('今回請求金額を入力してください。');
      existsError = true;
      setOpen(true);
    } else if (isNaN(Number(balanceTotal))) {
      setErrorMessage('残金を入力してください。');
      existsError = true;
      setOpen(true);
    } else {
      estimates.forEach((estimate: Estimate) => {
        if (estimate.id === 0) {
          setErrorMessage('見積番号を指定してください。');
          existsError = true;
          setOpen(true);
          return;
        }
      });
      if (existsError) {
        return;
      }

      setShowLinearProgress(true);

      let invoiceEstimate: any = [];
      estimates.forEach((obj: Estimate) => {
        invoiceEstimate.push({
          id: obj.id,
          estimate_id: obj.id,
          quantity: obj.quantity,
          code: obj.code,
          construction_name: obj.constructionName,
          invoice_price: obj.invoicePrice
        });
      });

      if (params.id) {
        let alreadyPaidNum = parseInt(alreadyPaid);

        updateInvoices(
          params.id,
          status,
          clientName,
          honorificTitle,
          contractorName,
          paymentDateValue,
          payee,
          publishedDateValue,
          confirmDate !== null ? confirmDateValue : '',
          constructId,
          constructSub,
          billingUserId,
          salesUserId,
          outPutPdf,
          outPutDetails,
          deliveryMethodId,
          billingTypeId,
          freeField,
          Number(contractTotal),
          Number(alreadyPaidNum),
          Number(billingTotal),
          Number(balanceTotal),
          taxRule,
          remarks.trim(),
          memo.trim(),
          invoiceEstimate,
          receiptNote
        ).then(data => {
          if (data === 'Not logged in!') {
            changeLoggedInData('Not logged in!');
          } else {
            if (typeof data === 'string') {
              setErrorMessage(data);
              setOpen(true);
            } else {
              if (data.error) {
                setErrorMessage(data.error);
                setOpen(true);
                setShowLinearProgress(false);
              } else {
                setIsRendered(false);
                setErrorMessage(data.message);
                getListOfUsers();
                getTheDetailsOfInvoices(Number(params.id), goPreview);
              }
            }
          }
        });
      } else {
        let alreadyPaidNum = parseInt(alreadyPaid);
        let newClientId = history.location.state.state
          ? history.location.state.state.state
          : null;
        createInvoices(
          status,
          clientName,
          honorificTitle,
          contractorName,
          paymentDateValue,
          payee,
          publishedDateValue,
          confirmDate !== null ? confirmDateValue : '',
          constructId,
          constructSub,
          billingUserId,
          salesUserId,
          outPutPdf,
          outPutDetails,
          deliveryMethodId,
          billingTypeId,
          freeField,
          Number(contractTotal),
          Number(alreadyPaidNum),
          Number(billingTotal),
          Number(balanceTotal),
          taxRule,
          remarks.trim(),
          memo.trim(),
          invoiceEstimate,
          newClientId,
          receiptNote
        ).then(data => {
          if (data === 'Not logged in!') {
            changeLoggedInData('Not logged in!');
          } else {
            if (typeof data === 'string') {
              setErrorMessage(data);
              setOpen(true);
            } else {
              if (data.error) {
                setErrorMessage(data.error);
                setOpen(true);
                setShowLinearProgress(false);
              } else {
                setErrorMessage(data.message);
                setOpenSuccess(true);
                setIsRendered(false);
                getListOfUsers();
                getTheDetailsOfInvoices(data.new_invoice_id, goPreview);
                getUnbilledAlerts(setAlertList);
              }
            }
          }
        });
      }
    }
  };

  const deleteInvoice = () => {
    deleteSingleInvoice(params.id).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
            setTimeout(() => {
              history.goBack();
            }, 2000);
          }
        }
      }
    });
  };

  /**
   * 今回請求金額（税込）の計算
   */
  useEffect(() => {
    let billingTotalPrice = Number(billingTotal);
    let billingTotaltTax = calcTax(billingTotalPrice, taxRate, taxRule);
    billingTotalPrice += billingTotaltTax;
    setBillingTotalTax(Number(billingTotaltTax) ? Number(billingTotaltTax) : 0);
    setBillingTotalPrice(billingTotalPrice);
  }, [estimates, taxRate, taxRule, billingTotal]);

  /**
   * 見積書項目の合計金額の計算
   */
  useEffect(() => {
    let totalPrice = estimates.reduce(
      (total, estimate) => total + estimate.billingTotalSum,
      0
    );
    if (isRendered) {
      if (totalPrice === 0) {
        setContractTotal(undefined);
      } else {
        setContractTotal(totalPrice);
      }
    }
    setIsRendered(true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estimates]);

  const BalanceCalculation = useCallback(
    (total: number, already: number, billing: number) => {
      const balance = total - already - billing;
      setBalanceTotal(String(balance));
    },
    [contractTotal, setAlreadyPaid, setBillingTotal]
  );

  useEffect(() => {
    BalanceCalculation(
      contractTotal === null || '' || isNaN(Number(contractTotal))
        ? 0
        : Number(contractTotal),
      alreadyPaid === null || '' || isNaN(Number(alreadyPaid))
        ? 0
        : Number(alreadyPaid),
      billingTotal === null || '' || isNaN(Number(billingTotal))
        ? 0
        : Number(billingTotal)
    );
  }, [contractTotal, alreadyPaid, billingTotal]);

  /**
   * 今回請求金額の税込金額から税抜金額を逆算
   */
  const handleBillingTotalPriceChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let newBillingTotalPrice = !isNaN(parseInt(e.target.value))
        ? parseInt(e.target.value)
        : 0;
      // 税抜金額を税込 / (1 + 税率)を四捨五入した値で推定し、
      // 推定値の税込金額が指定された税込金額と一致するように調整する
      let estimatedBillingTotal = Math.round(
        newBillingTotalPrice / (1 + taxRate)
      );
      let estimatedBillingTotalTax = calcTax(
        estimatedBillingTotal,
        taxRate,
        taxRule
      );
      let estimatedBillingTotalPrice =
        estimatedBillingTotal + estimatedBillingTotalTax;

      // もし、税込金額が指定された税込金額と一致していたら、そのままステートを更新して終了
      if (estimatedBillingTotalPrice === newBillingTotalPrice) {
        setBillingTotal(estimatedBillingTotal);
        setBillingTotalTax(estimatedBillingTotalTax);
        setBillingTotalPrice(estimatedBillingTotalPrice);
        return;
      }

      // 一致しなかった場合、税抜金額の調整を行う
      estimatedBillingTotal = adjustBillingTotal(
        estimatedBillingTotal,
        newBillingTotalPrice
      );
      estimatedBillingTotalTax = calcTax(
        estimatedBillingTotal,
        taxRate,
        taxRule
      );
      estimatedBillingTotalPrice =
        estimatedBillingTotal + estimatedBillingTotalTax;
      if (estimatedBillingTotalPrice === newBillingTotalPrice) {
        setBillingTotal(estimatedBillingTotal);
        setBillingTotalTax(estimatedBillingTotalTax);
        setBillingTotalPrice(estimatedBillingTotalPrice);
        return;
      }

      // ここまで来たら、指定された税込金額になる税抜金額が存在しないということ。
      // また、2回連続で指定できない税込金額が入力された場合、計算結果は同じになり再レンダリングされないので
      // ステートが更新されず、表示部分にはそのまま指定できない値が表示されてしまう。
      // そのため、ここまで来ることのない値である0にセットしてステートを更新する
      setBillingTotalPrice(0);
      setTimeout(() => {
        setBillingTotal(estimatedBillingTotal);
        setBillingTotalTax(estimatedBillingTotalTax);
        setBillingTotalPrice(estimatedBillingTotalPrice);
      }, 0);
      window.alert(
        `現在の小数点以下の設定では指定された${newBillingTotalPrice}円の税込金額になる税抜金額が存在しません。`
      );
    },
    [taxRate, taxRule]
  );

  /**
   * 請求金額の税抜金額から税込金額を逆算するためのヘルパー関数
   * @param estimatedBillingTotal 税抜金額の推定値
   * @param newBillingTotalPrice 指定された税込金額
   * @returns 調整後の税抜金額
   */
  const adjustBillingTotal = useCallback(
    (estimatedBillingTotal: number, newBillingTotalPrice: number) => {
      let estimatedBillingTotalTax = calcTax(
        estimatedBillingTotal,
        taxRate,
        taxRule
      );
      let estimatedBillingTotalPrice =
        estimatedBillingTotal + estimatedBillingTotalTax;
      if (estimatedBillingTotalPrice === newBillingTotalPrice) {
        return estimatedBillingTotal;
      } else if (estimatedBillingTotalPrice > newBillingTotalPrice) {
        return estimatedBillingTotal - 1;
      } else {
        return estimatedBillingTotal + 1;
      }
    },
    [taxRate, taxRule]
  );

  /**
   * 請求区分が一括の場合、御契約金額（税抜）を今回請求金額（税抜）に反映
   */
  useEffect(() => {
    if (billingTypeId === BILLING_TYPE.ONE_TIME_PAYMENT) {
      setBillingTotal(contractTotal);
    }
  }, [billingTypeId, contractTotal]);

  // 請求先顧客名のハンドラー
  const handleClientTextareaChange = (text: string) => {
    const rawText = text;
    let cleanText = '';
    let charCount = 0; // 全体の文字数カウント
    let lineCharCount = 0; // 各行の文字数カウント
    let lineCount = 1; // 行数カウント

    for (let i = 0; i < rawText.length; i++) {
      // 文字が改行コードかチェック
      if (rawText[i] === '\n' || rawText[i] === '\r') {
        // Windowsの改行コード（\r\n）を考慮
        if (rawText[i] === '\r' && rawText[i + 1] === '\n') {
          i++;
        }
        lineCount++;
        lineCharCount = 0; // 各行の文字数カウントをリセット

        if (lineCount > 2) {
          alert('2行まで入力可能です');
          break;
        }
        cleanText += rawText[i];
      } else {
        charCount++;
        lineCharCount++;

        // 改行がある場合のみ各行の20文字制限を適用
        if (lineCount > 1 && lineCharCount > 20) {
          alert('1行あたり20文字まで入力可能です');
          break;
        }

        // 全体の40文字制限
        if (charCount > 40) {
          alert('40文字まで入力可能です');
          break;
        }
        cleanText += rawText[i];
      }
    }

    setClientName(cleanText);
  };

  // フォーカスが外れたときに改行後に文字が入っていない場合、改行を削除
  const handleClientTextareaBlur = () => {
    if (clientName.endsWith('\n') || clientName.endsWith('\r')) {
      setClientName(clientName.slice(0, -1));
    }
  };

  useEffect(() => {
    getListOfUsers();
    if (source === 'customer' || constructId === null) {
      getListOfEstimatesByClient();
    } else {
      getListOfConstructionEstimates();
    }

    getListOfBillingCategory();
    getListOfDeliveryMethods();
    if (params.id) {
      getTheDetailsOfInvoices();
    } else {
      getCompanyFreeField().then(data => {
        setFreeField(data.data);
      });
      if (source === 'customer' || constructId === null) {
        getBankList().then(data => {
          setPayee(data.data);
        });
      }
      getConstructionDetails(history.location.state.constructId).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (source === 'customer') {
            if (
              history.location.state.selectedDepositeSiteMonth &&
              history.location.state.selectedDepositeSiteDate
            ) {
              const depositMonth =
                history.location.state.selectedDepositeSiteMonth;
              const depositDate =
                history.location.state.selectedDepositeSiteDate;
              setDepositSite(`${depositMonth}-${depositDate}`);
            }
            if (history.location.state.selectedEndofDay) {
              setClosingDateId(history.location.state.selectedEndofDay);
            }
            if (history.location.state.endOfDay) {
              setEndOfDay(history.location.state.endOfDay);
            }
            if (history.location.state.clientId) {
              setClientId(history.location.state.clientId);
            }
            if (history.location.state.salesUserId) {
              setSalesUserId(history.location.state.salesUserId);
            }
            setConstructSub(location.state.clientname);
            setReceiptNote(location.state.clientname);
            setClientName(location.state.clientname);
          }
          if (!history.location.state.constructId) {
            setErrorMessage(`No constructId provided`);
            return;
          }

          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            setConstructId(history.location.state.constructId);
            setConstructCode(data.data.code);
            setClientId(data.data.client_id);
            setClosingDateId(data.data.client_closing_date_id);
            setDepositSite(data.data.client_deposit_site);
            setClientName(data.data.client_name);
            setContractorName(data.data.contractor_name);
            setConstructSub(data.data.name);
            setReceiptNote(data.data.name);
            if (data.data.sales_staff_id) {
              setSalesUserId(data.data.sales_staff_id);
            } else {
              setSalesUserId(data.data.first_in_charge_id);
            }
            setPayee(data.data.company.payee);
            setAlreadyPaid(data.data.already_paid);
            getAllEndOfDay();
          }
        }
      });
      setLoading(false);
    }
  }, [
    // eslint-disable-line react-hooks/exhaustive-deps
    getListOfUsers,
    getListOfConstructionEstimates,
    getListOfEstimatesByClient,
    getListOfBillingCategory,
    getListOfDeliveryMethods,
    changeLoggedInData,
    history.location.state.rowId,
    params.id
  ]);
  useEffect(() => {
    if (constructId === null) {
      getConstructId_by_client(clientId)
        .then(data => {
          if (data === 'Not logged in!') {
            changeLoggedInData('Not logged in!');
          } else {
            if (typeof data === 'string') {
              setErrorMessage(data);
              setOpen(true);
            } else {
              if (data.error) {
                setErrorMessage(data.error);
                setOpen(true);
              } else {
                const constructIds = data.construction_ids;

                const estimatePromises = constructIds.map((id: number) =>
                  getConstructEstimate(id)
                );

                Promise.all(estimatePromises)
                  .then(results => {
                    const allData = results.flatMap(result => result.data);
                    const sortedData = allData.sort((a, b) => b.id - a.id);
                    const maxId = sortedData.reduce(
                      (max, item: any) => (item.id > max ? item.id : max),
                      0
                    );
                    const no_estimate = {
                      id: maxId + 1,
                      code: '見積書なし',
                      construct_sub: '',
                      billingTotal: 0,
                      constructionName: '',
                      isIssued: 0 // 発行済みかどうかに関係なく0
                    };
                    const estimatesWithStatusPromises = sortedData.map(
                      async estimate => {
                        try {
                          const response = await checkInvoiceByEstimateId(
                            estimate.id
                          );
                          const isIssued =
                            response.data && response.data.exists ? 1 : 0;
                          return {
                            ...estimate,
                            isIssued
                          };
                        } catch (err) {
                          return {
                            ...estimate,
                            isIssued: 0 // エラーが発生した場合は未発行として扱う
                          };
                        }
                      }
                    );

                    Promise.all(estimatesWithStatusPromises)
                      .then(estimatesWithStatus => {
                        setConstructionEstimates([
                          ...estimatesWithStatus,
                          no_estimate
                        ]);
                        if (!params.id && !history.location.state.estimateId) {
                          setTaxRate(results[0]?.tax_rate || 0);
                        }
                        if (!params.id && history.location.state.estimateId) {
                          let arr: any = [];
                          const obj: any = {
                            id: sortedData[0].id,
                            quantity: 1,
                            constructionName: sortedData[0].construction_name,
                            billingTotal: sortedData[0].billing_total,
                            billingTotalSum: sortedData[0].billing_total * 1,
                            isIssued: estimatesWithStatus[0].isIssued
                          };
                          arr.push(obj);
                          setEstimates(arr);
                        }
                      })
                      .catch(err => {
                        setErrorMessage(
                          '見積書データの取得中にエラーが発生しました。'
                        );
                        setOpen(true);
                      });
                  })
                  .catch(err => {
                    setErrorMessage(
                      '見積書データの取得中にエラーが発生しました。'
                    );
                    setOpen(true);
                  });
              }
            }
          }
        })
        .catch(err => {
          if (err.response) {
            if (err.response.data) {
              setErrorMessage(
                err.response.data.error || 'エラーが発生しました。'
              );
            } else {
              setErrorMessage('サーバーからの予期しないエラーが発生しました。');
            }
          } else if (err.request) {
            setErrorMessage('サーバーからの応答がありません。');
          } else {
            setErrorMessage('リクエストの設定中にエラーが発生しました。');
          }
          setOpen(true);
        });
    }
  }, [constructId]);

  // パンくずリスト用に検索パラメーターを設定
  const patternState: TTopicPathState = {};
  patternState['/invoices'] = history.location.state;

  // パンくずリスト表示パターン(編集)
  let patternName = 'invoices_edit';

  // 新規作成画面のモードの場合
  // 新規作成モードの場合呼び出し元が2種類あるため、呼び出し元のURLで処理切り分け
  if (location.pathname.match('create')) {
    // 遷移元画面のURL取得
    const url: string | undefined = location.state.url;

    // 遷移元が「受取書類」の場合
    if (url?.match('received/outsource-orders')) {
      // パンくずリスト表示パターン(新規)
      patternName = 'estimates_invoice_create';
    } else {
      // パンくずリスト表示パターン(新規)
      patternName = 'invoices_create';
    }
  }

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <AppBarComponent patternName={patternName} patternState={patternState} />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <div
          style={{
            overflow: 'hidden',
            backgroundColor: '#F5F5F5',
            minHeight: window.innerHeight - 120
          }}
        >
          <div style={{ margin: 15 }}>
            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
              <Alert onClose={handleClose} severity='error'>
                {errorMessage}
              </Alert>
            </Snackbar>

            <Snackbar
              open={openSuccess}
              autoHideDuration={4000}
              onClose={handleCloseSuccess}
            >
              <Alert onClose={handleCloseSuccess} severity='success'>
                {errorMessage}
              </Alert>
            </Snackbar>

            {/* 帳票削除のアラート */}
            <DocumentDeleteModal
              documentType={'請求書'}
              documentDeleteModal={documentDeleteModal}
              setDocumentDeleteModal={setDocumentDeleteModal}
              deleteDocument={deleteInvoice}
            />

            <ReturnButton matches2={matches2} history={history} />

            {showLinearProgress && (
              <LinearProgress className={classes.progress} />
            )}

            <div style={{ backgroundColor: '#FFFFFF', marginBottom: 15 }}>
              <div className='table-top-container-customer'>
                <div
                  style={{
                    fontWeight: 'bold',
                    padding: 15,
                    paddingBottom: 0,
                    fontSize: 24
                  }}
                >
                  {params.id ? '請求書編集' : '請求書作成'}
                  {source === 'customer' ? '（顧客別）' : '（工事別）'}
                </div>
              </div>

              <Grid container style={{ marginBottom: 15 }}>
                <Grid item xs={matches2 ? 4 : 12}>
                  <TableTitle title='請求書番号' height={60}>
                    <div className={classes.fixedTextContainer}>
                      {invoiceCode}
                    </div>
                  </TableTitle>

                  <TableTitle
                    title={source === 'customer' ? '請求書件名' : '工事件名'}
                    height={60}
                  >
                    {source === 'customer' ? (
                      <InputArea
                        value={constructSub}
                        onChange={setConstructSub}
                        placeholder='件名を入力'
                        maxLength={60}
                      />
                    ) : (
                      <div className={classes.fixedTextContainer}>
                        <div style={{ fontSize: 11 }}>{constructSub}</div>
                      </div>
                    )}
                  </TableTitle>

                  <TableTitle
                    title={
                      <>
                        ステータス<span>*</span>
                      </>
                    }
                    height={60}
                  >
                    <div className={classes.inputContainerSelectBox}>
                      <select
                        value={status}
                        onChange={text => {
                          setStatus(parseInt(text.target.value));
                        }}
                        className={classes.selectBoxStyle}
                        form='carform'
                      >
                        {/* <option value={0}>選択してください</option> */}
                        <option value={1}>送付</option>
                        <option value={2}>未送付</option>
                      </select>
                    </div>
                  </TableTitle>

                  <TableTitle
                    title={
                      <>
                        請求先顧客名<span>*</span>
                      </>
                    }
                    height={100}
                  >
                    <div
                      className={classes.inputContainer}
                      style={{ width: '70%' }}
                    >
                      <textarea
                        value={clientName}
                        placeholder='40文字以内、2行以内'
                        maxLength={40}
                        onChange={text => {
                          handleClientTextareaChange(text.target.value);
                        }}
                        onBlur={handleClientTextareaBlur}
                        className={classes.input}
                        style={{ height: 100, maxHeight: 100 }}
                      />
                    </div>
                    <div
                      className={classes.inputContainer}
                      style={{ width: '30%', marginLeft: 0, paddingRight: 0 }}
                    >
                      <select
                        value={honorificTitle}
                        onChange={text => {
                          setHonorificTitle(text.target.value);
                        }}
                        className={classes.selectBoxStyle}
                      >
                        {/* <option value={0}>選択してください</option> */}
                        <option value='御中'>御中</option>
                        <option value='様'>様</option>
                      </select>
                    </div>
                  </TableTitle>
                  <TableTitle title='契約者名' height={60}>
                    <InputArea
                      value={contractorName}
                      onChange={setContractorName}
                      placeholder='30文字以内'
                      maxLength={30}
                    />
                  </TableTitle>

                  <DateField
                    text='支払期日'
                    date={paymentDate}
                    onChange={handlePaymentDateChange}
                    id={'payment_date'}
                    help={
                      <CustomTooltip
                        title={tooltipContents.paymentDateAuto}
                        placement='top'
                        interactive
                      >
                        <HelpIcon style={{ color: 'white', marginLeft: 8 }} />
                      </CustomTooltip>
                    }
                  />

                  <TableTitle title='振込先' height={120}>
                    <div className={classes.inputContainer}>
                      <textarea
                        value={payee}
                        rows={3}
                        maxLength={200}
                        onChange={text => {
                          setPayee(text.target.value);
                        }}
                        className={classes.inputBank}
                      />
                    </div>
                  </TableTitle>
                </Grid>

                <Grid item xs={matches2 ? 4 : 12}>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <DateField
                    text='請求書発行日'
                    date={publishedDate}
                    onChange={handlePublishedDateChange}
                    id={'published_date'}
                    span={true}
                  />
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <DateField
                    text='入金日'
                    date={confirmDate}
                    onChange={handleConfirmDateChange}
                    id={'confirm_date'}
                    emptyLabel={'日付を選択'}
                    disabled={receiptIssueFlg === 1}
                  />
                  {source !== 'customer' && (
                    <TableTitle title='工事番号' height={60}>
                      <div className={classes.fixedTextContainer}>
                        {constructCode}
                      </div>
                    </TableTitle>
                  )}

                  <TableTitle title='請求者' height={60}>
                    <SelectPullDown
                      value={billingUserId}
                      setValue={setBillingUserId}
                      options={userData}
                      width='100%'
                      initialUserData={initialBillingUserData}
                    />
                  </TableTitle>
                  <TableTitle
                    title={
                      <>
                        営業担当<span>*</span>
                      </>
                    }
                    height={60}
                  >
                    <SelectPullDown
                      value={salesUserId}
                      setValue={setSalesUserId}
                      options={userData}
                      width='90%'
                      initialUserData={initialSalesUserData}
                    />
                    <Checkbox
                      checked={outPutPdf}
                      onChange={outPutCheck}
                      color='default'
                    />
                    <CustomTooltip
                      title={tooltipContents.salesOutput}
                      placement='right'
                    >
                      <HelpIcon color='action' style={{ marginRight: 8 }} />
                    </CustomTooltip>
                  </TableTitle>
                  <TableTitle
                    title={
                      <>
                        送付区分<span>*</span>
                      </>
                    }
                    height={60}
                  >
                    <SelectPullDown
                      value={deliveryMethodId}
                      setValue={setDeliveryMethodId}
                      options={deliveryMethod}
                      width='100%'
                    />
                  </TableTitle>
                  <TableTitle
                    title={
                      <>
                        請求区分<span>*</span>
                      </>
                    }
                    height={60}
                  >
                    <SelectPullDown
                      value={billingTypeId}
                      setValue={setBillingTypeId}
                      options={billingCategory}
                      width='100%'
                    />
                  </TableTitle>
                  <TableTitle
                    title={
                      <>
                        自由記入欄
                        <CustomTooltip
                          title={tooltipContents.invoiceFreeField}
                          placement='top'
                          interactive
                        >
                          <HelpIcon style={{ color: 'white', marginLeft: 8 }} />
                        </CustomTooltip>
                      </>
                    }
                    height={60}
                    marginBottom={15}
                  >
                    <InputArea
                      value={freeField}
                      onChange={setFreeField}
                      placeholder='50文字以内'
                      maxLength={50}
                    />
                  </TableTitle>
                  <TableTitle
                    title={
                      <>
                        領収書但し書き<span>*</span>
                      </>
                    }
                    height={60}
                  >
                    <InputArea
                      value={receiptNote}
                      onChange={setReceiptNote}
                      placeholder='60文字以内'
                      maxLength={60}
                    />
                  </TableTitle>
                </Grid>

                <Grid
                  item
                  xs={matches2 ? 4 : 12}
                  style={{ paddingRight: matches2 ? 15 : 0 }}
                >
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <TableTitle title='作成者' height={60}>
                    <UserDate user={createdUser} dateTime={createdAt} />
                  </TableTitle>
                  <TableTitle title='修正者' height={60} marginBottom={15}>
                    <UserDate user={updatedUser} dateTime={updatedAt} />
                  </TableTitle>

                  <TableTitle
                    title={
                      <>
                        御契約金額（税抜）<span>*</span>
                      </>
                    }
                    height={60}
                  >
                    <PriceInput
                      value={contractTotal}
                      handleChange={e => {
                        const sanitizedValue = e.target.value.replace(/,/g, '');
                        setContractTotal(parseInt(sanitizedValue, 10));
                      }}
                    />
                  </TableTitle>

                  <TableTitle title='御支払済金額（税抜）' height={60}>
                    <PriceInput
                      value={alreadyPaid}
                      handleChange={e => {
                        setAlreadyPaid(e.target.value);
                      }}
                    />
                  </TableTitle>
                  <TableTitle
                    title={
                      <>
                        今回請求金額（税抜）<span>*</span>
                      </>
                    }
                    height={60}
                  >
                    <PriceInput
                      value={billingTotal ? billingTotal : ''}
                      handleChange={e => {
                        const sanitizedValue = e.target.value.replace(/,/g, '');
                        setBillingTotal(parseInt(sanitizedValue, 10));
                      }}
                    />
                  </TableTitle>
                  <TableTitle
                    title={
                      <>
                        残金（税抜）<span>*</span>
                      </>
                    }
                    height={60}
                  >
                    <PriceInput
                      value={balanceTotal}
                      handleChange={e => {
                        const sanitizedValue = e.target.value.replace(/,/g, '');
                        setBalanceTotal(parseInt(sanitizedValue, 10));
                      }}
                    />
                  </TableTitle>
                  <TableTitle title='消費税' height={60}>
                    <div className={classes.textContainerPrice}>
                      {billingTotalTax}
                    </div>
                  </TableTitle>
                  <TableTitle
                    title={
                      <>
                        <CustomTooltip
                          title={tooltipContents.billingTotalPrice}
                          placement='top'
                          interactive
                        >
                          <HelpIcon
                            style={{ color: 'white', marginRight: 8 }}
                          />
                        </CustomTooltip>
                        {'今回請求金額（税込)'}
                      </>
                    }
                    height={60}
                  >
                    <PriceInput
                      value={billingTotalPrice ? billingTotalPrice : '0'}
                      handleBlur={e => {
                        handleBillingTotalPriceChange(e);
                      }}
                    />
                  </TableTitle>
                  <TableTitle title='消費税の小数点以下' height={60}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                      }}
                    >
                      {/* 切捨て */}
                      <div
                        onClick={() => setTaxRule(TAX_RULE.FLOOR)}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: 8
                        }}
                      >
                        <div className='checkbox'>
                          {taxRule === TAX_RULE.FLOOR && (
                            <div className='dot' />
                          )}
                        </div>
                        <div style={{ fontSize: 16, marginLeft: 5 }}>
                          切捨て
                        </div>
                      </div>

                      {/* 切上げ */}
                      <div
                        onClick={() => setTaxRule(TAX_RULE.CEIL)}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: 8
                        }}
                      >
                        <div className='checkbox'>
                          {taxRule === TAX_RULE.CEIL && <div className='dot' />}
                        </div>
                        <div style={{ fontSize: 16, marginLeft: 5 }}>
                          切上げ
                        </div>
                      </div>

                      {/* 四捨五入 */}
                      <div
                        onClick={() => setTaxRule(TAX_RULE.ROUND)}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          padding: 8
                        }}
                      >
                        <div className='checkbox' style={{ borderColor: '' }}>
                          {taxRule === TAX_RULE.ROUND && (
                            <div
                              className='dot'
                              style={{ backgroundColor: '' }}
                            />
                          )}
                        </div>
                        <div style={{ fontSize: 16, marginLeft: 5 }}>
                          四捨五入
                        </div>
                      </div>
                    </div>
                  </TableTitle>
                </Grid>
              </Grid>
              <div style={{ height: 10, backgroundColor: '#FFFFFF' }}></div>
            </div>
            <EstimatesTable
              source={source}
              estimates={estimates}
              setEstimates={setEstimates}
              constructionEstimates={constructionEstimates}
              outPutDetails={outPutDetails}
              setOutPutDetails={setOutPutDetails}
              memo={memo}
              setMemo={setMemo}
              remarks={remarks}
              setRemarks={setRemarks}
            />
          </div>
          <div style={{ height: 80 }} />
          <InvoiceFooter
            params={params}
            showLinearProgress={showLinearProgress}
            updateOrCreateInvoiceDetails={updateOrCreateInvoiceDetails}
            setDocumentDeleteModal={setDocumentDeleteModal}
          />
        </div>
      )}
    </>
  );
};
